<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-box">
      <div class="plant-wrapper-select">
        <div style="margin-right: 1vw">
          <DropDown
            :content="warehouseTitle"
            :items="warehouse"
            @sendInfo="showInfoW"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="buildingTitle"
            :items="building"
            @sendInfo="showInfoB"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="floorTitle"
            :items="floor"
            @sendInfo="showInfoF"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="areaTitle"
            :items="area"
            @sendInfo="showInfoA"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="stackTitle"
            :items="stack"
            @sendInfo="showInfoS"
          ></DropDown>
        </div>
      </div>
      <div class="plant-wrapper-select">
        <div style="margin-right: 1vw; position: relative; z-index: 7">
          <DropDown
            content="请选择状态"
            :items="statusData"
            v-on:sendInfo="showInfoStatus"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw; position: relative; z-index: 7">
          <DropDown
            content="请选择虫情类型"
            :items="typeData"
            v-on:sendInfo="showInfoType"
          ></DropDown>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="query button" @click="handleSearch(1)">查询</div>
      </div>
    </div>
    <div class="plant-wrapper-content">
      <div class="plant-wrapper-content-top">
        <div class="fif-font-wrapper" @click="newPlant">
          <div class="icon-font">&#xe605;</div>
          新建虫情板
        </div>
        <div class="four-font-wrapper" @click="deleteAll">
          <div class="icon-font">&#xe646;</div>
          批量删除
        </div>
        <div class="four-font-wrapper" @click="historyPlant">
          <div class="icon-font">&#xe600;</div>
          历史记录
        </div>
        <div class="six-font-wrapper" @click="regularPlant">
          <div class="icon-font">&#xe608;</div>
          监控规则设置
        </div>
      </div>
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 5%">
              <div
                class="select-icon"
                :class="{ 'select-icon-active': all }"
                @click="selectAll"
              ></div>
            </div>
            <div class="detail-item" style="width: 10%">虫情板ID</div>
            <div class="detail-item" style="width: 5%">虫情类型</div>
            <div class="detail-item" style="width: 20%">仓库位置</div>
            <div class="detail-item" style="width: 10%">负责人</div>
            <div class="detail-item" style="width: 10%">创建日期</div>
            <div class="detail-item" style="width: 10%">到期日期</div>
            <div class="detail-item" style="width: 5%">状态</div>
            <div class="detail-item" style="width: 5%">备注</div>
            <div class="detail-item" style="width: 20%">操作</div>
          </div>
          <div class="detail-content">
            <div
              class="detail-list-wrapper"
              v-if="!loading && tableData.length > 0"
              v-for="(data, index) in tableData"
              :key="index"
            >
              <div class="detail-item" style="width: 5%">
                <div
                  class="select-icon"
                  :class="{ 'select-icon-active': data.sign === 1 }"
                  @click="selectSingle(data.id)"
                ></div>
              </div>
              <div class="detail-item" style="width: 10%">
                {{ data.pestBoardId }}
              </div>
              <div class="detail-item" style="width: 5%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.boardType"
                >
                  <div
                    class="popover"
                    style="width: 8vw; text-align: center"
                    slot="reference"
                  >
                    {{ data.boardType }}
                  </div>
                </el-popover>
              </div>
              <div class="detail-item" style="width: 20%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.siteName"
                >
                  <div
                    class="popover"
                    style="width: 8vw; text-align: center"
                    slot="reference"
                  >
                    {{ data.siteName }}
                  </div>
                </el-popover>
              </div>
              <div class="detail-item" style="width: 10%">
                {{ data.principalName }}
              </div>
              <div class="detail-item" style="width: 10%">
                {{ data.useTimeStart }}
              </div>
              <div class="detail-item" style="width: 10%">
                {{ data.useTimeEnd }}
              </div>
              <div
                class="detail-item"
                style="width: 5%"
                :class="{
                  'color-red': data.isExpire === 0,
                  'color-green': data.isExpire === 1,
                }"
              >
                {{ data.isExpire === 0 ? "已到期" : "未到期" }}
              </div>
              <div class="detail-item" style="width: 5%" v-if="!data.remark">
                --
              </div>
              <div class="detail-item" style="width: 5%" v-if="data.remark">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.remark"
                >
                  <div class="popover" slot="reference">{{ data.remark }}</div>
                </el-popover>
              </div>
              <div class="detail-item" style="width: 20%">
                <div class="item-btn item-look" @click="lookPlant(data)">
                  查看
                </div>
                <div class="item-btn item-change" @click="changePlant(data.id)">
                  变更
                </div>
                <div
                  class="item-btn item-history"
                  @click="toChangeHistory(data.pestBoardId)"
                >
                  变更历史
                </div>
                <div class="item-btn item-delete" @click="deleteCrib(data.id)">
                  删除
                </div>
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length < 1">
              暂无数据
            </div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > rows">
            <div class="page-wrapper-left">
              共{{ total }}条数据,共{{ Allpages }}页，每页显示{{
                rows
              }}条，当前第{{ page }}页
            </div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="Tzpage">跳转至</div>
              <div class="page-btn">
                <input @blur="Tzpage" v-model="page" />
              </div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="alert-box" v-if="show">
            <div class="alert-content">
              <div class="alert-content-title">删除提醒</div>
              <div class="alert-content-msg">是否确认删除选中数据?</div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelDelete">取消</div>
                <div class="btn-confirm button" @click="confirmDelete">
                  确认
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="alert-box" v-if="showChange">
            <div class="alert-content">
              <div class="alert-content-title">变更提醒</div>
              <div class="alert-content-msg" style="padding-bottom: 0">
                <div class="input-contain">
                  <div class="input-title">启用时间：</div>
                  <div class="input-wrapper" style="margin-right: 0">
                    <el-date-picker
                      v-model="changeValue.pestBoardUserStart"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="alert-content-msg">
                <div class="input-contain">
                  <div class="input-title">使用天数：</div>
                  <div class="input-suffix-wrapper" style="margin-right: 0">
                    <input v-model="changeValue.useDays" placeholder="" />
                    <div class="input-suffix">(天)</div>
                  </div>
                </div>
              </div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelChange">取消</div>
                <div class="btn-confirm button" @click="confirmChange">
                  确认
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from "../../../components/DropDownSingle.vue";
import { warehouseNode } from "../../../api/basic";
import {
  queryBoard,
  delBoard,
  bathDelBoard,
  pestChange,
  selectPestType,
} from "../../../api/maintain";
export default {
  name: "PlantIndex",
  components: { DropDown },
  data() {
    return {
      showChange: false,
      changeValue: {
        pkId: "",
        pestBoardUserStart: "",
        useDays: "",
      },
      show: false,
      all: false,
      id: "",
      type: 0,
      idList: [],
      value: "",
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      stack: [],
      warehouseTitle: "请选择仓库",
      buildingTitle: "请选择楼号",
      floorTitle: "请选择层号",
      areaTitle: "请选择区号",
      stackTitle: "请选择垛位",
      statusData: [
        { name: "全部", value: "" },
        { name: "到期", value: 0 },
        { name: "未到期", value: 1 },
      ],
      typeData: [{name: "全部", value: ""}],
      loading: true,
      startDate: "",
      endDate: "",
      siteId: "",
      siteType: "",
      boardType: "",
      status: "",
      page: 1,
      rows: 7,
      total: "",
      // 总页数
      Allpages: 0,
      tableData: [],
    };
  },
  watch: {
    value: function () {
      this.startDate = this.value !== null ? this.value[0] : "";
      this.endDate = this.value !== null ? this.value[1] : "";
    },
  },
  created() {
    selectPestType()
      .then((res) => {
        let arr = res.data;
        console.log(res);
        this.typeData=this.typeData.concat(arr);
      })
      .catch((err) => {
        console.log(err);
      });
    let body = {
      warehouseNodeId: "",
      warehouseNodeType: "01",
    };
    warehouseNode(body)
      .then((res) => {
        this.warehouse = res.data;
        this.handleSearch(1);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    changePlant: function (id) {
      this.changeValue = {
        pkId: id,
        pestBoardUserStart: "",
        useDays: "",
      };
      this.showChange = true;
    },
    cancelChange: function () {
      this.showChange = false;
    },
    confirmChange: function () {
      pestChange(this.changeValue)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: "success",
              center: "true",
              duration: "1000",
            });
            this.showChange = false;
            this.handleSearch(1);
          } else {
            this.$message({
              message: res.message,
              type: "warning",
              center: "true",
              duration: "1000",
            });
            this.show = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoStatus: function (data) {
      this.status = data.value;
    },
    showInfoType: function (data) {
      this.boardType = data.name;
    },
    selectAll: function () {
      this.type = 1;
      this.all = !this.all;
      let idList = [];
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1;
          idList.push(data.id);
        });
        this.idList = idList;
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0;
          this.idList = [];
        });
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1;
          if (data.sign === 1) {
            this.idList.push(data.id);
          } else {
            let idList = [];
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item);
              }
            });
            this.idList = idList;
          }
          console.log(this.idList);
        }
      });
      this.all = this.idList.length === this.tableData.length;
    },
    deleteCrib: function (id) {
      this.show = true;
      this.id = id;
      this.type = 0;
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true;
        this.type = 1;
      } else {
        this.$message({
          message: "请选择要删除的数据!",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
      console.log(this.idList);
    },
    cancelDelete: function () {
      this.show = false;
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          id: this.id,
        };
        console.log(body);
        delBoard(body)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data,
              type: "success",
              center: "true",
              duration: "1000",
            });
            this.show = false;
            this.id = "";
            this.handleSearch();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let body = {
          idList: this.idList.join(),
        };
        console.log(body);
        bathDelBoard(body)
          .then((res) => {
            console.log(res);
            this.all = false;
            this.idList = [];
            this.$message({
              message: res.data,
              type: "success",
              center: "true",
              duration: "1000",
            });
            this.show = false;
            this.handleSearch();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    toChangeHistory: function (id) {
      console.log(id);
      this.$router.push({
        path: "/plant/changeHistory",
        query: {
          index: "4",
          pestBoardId: id,
        },
      });
    },
    lookPlant: function (data) {
      this.$router.push({
        path: "/plant/lookPlant",
        query: {
          index: "4",
          pestBoardId: data.pestBoardId,
          siteName: data.siteName,
        },
      });
    },
    regularPlant: function () {
      this.$router.push({
        path: "/plant/regularPlant",
        query: {
          index: "4",
        },
      });
    },
    historyPlant: function () {
      this.$router.push({
        path: "/plant/historyPlant",
        query: {
          index: "4",
        },
      });
    },
    newPlant: function () {
      this.$router.push({
        path: "/plant/newPlant",
        query: {
          index: "4",
        },
      });
    },
    showInfoW: function (data) {
      this.warehouseTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "02",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.building = res.data;
          this.buildingTitle = "请选择楼号";
          this.floor = [];
          this.floorTitle = "请选择层号";
          this.area = [];
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoB: function (data) {
      this.buildingTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "03",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.floor = res.data;
          this.floorTitle = "请选择层号";
          this.area = [];
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoF: function (data) {
      this.floorTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "04",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.area = res.data;
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoA: function (data) {
      this.areaTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "05",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          res.data.map((item) => {
            item.sign = 0;
          });
          this.stack = res.data;
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoS: function (data) {
      this.stackTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
    },
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1;
      }
      let body = {
        page: this.page,
        rows: this.rows,
        siteId: this.siteId,
        siteType: this.siteType,
        boardType: this.boardType,
        status: this.status,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.loading = true;
      queryBoard(body)
        .then((res) => {
          console.log(res);
          res.data.rows &&
            res.data.rows.map((item) => {
              item.sign = 0;
            });
          this.tableData = res.data.rows || [];
          this.total = res.data.total;
          this.loading = false;
          this.all = false;
          this.idList = [];
          // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        this.handleSearch();
      } else {
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/PlantIndex.vue